import { Component, HostBinding } from '@angular/core';

/**
 * Lab wrapper for the app page shell.
 *
 * The page surface is intentionally tiny: it only projects content and applies
 * the lab-owned app page flex chrome.
 */
@Component({
  selector: 'lab-page',
  standalone: true,
  template: '<ng-content />',
  styleUrl: './lab-page.component.scss',
})
export class LabPageComponent {
  @HostBinding('class')
  public readonly hostClass = 'lab-page';
}
